module.exports = __webpack_public_path__ + "static/media/21ECLAC10.6397a013.jpg";